<template>
<div>
  <div class="pinwall__assets">
    <button class="back" @click.stop.prevent="back()"><i class="material-icons">arrow_back</i></button>
    <button class="add" title="Edit Pinwall" @click.stop.prevent="openPinwall(selectedPinwall)"><i class="material-icons">edit</i></button>
    <button class="refresh" title="Refresh Assets" @click.stop.prevent="loadPinwallAssets(selectedPinwall)"><i class="material-icons">refresh</i></button>
    <div>
      <h3 class="title">{{selectedPinwall.name}}</h3>
    </div>
    <div class="password-form" v-if="selectedPinwall.private && !selectedPinwall.password">
      <label for="password" >Password</label>
      <input name="password" v-on:keyup.enter="login()" type="text" placeholder="Password" v-model="password" />
      <button class="pinwall__assets__btn password" title="Login" @click.stop.prevent="login()">Login</button>
    </div>
  </div>
  <div class="pinwall__list">
    <ul>
      <li class="pinwall__list__item" :title="'Select asset ' + asset.name" v-for="asset in filteredAssets" v-bind:key="asset.id" :style="'background:url(' +  asset.url + ') no-repeat center center'" @click.stop.prevent="selectAsset(asset)">
        <div class="title">{{asset.type + ' ' + asset.name.substring(0, 20)}}</div>
        <video width="300" controls v-if="asset.type === 'video' || asset.type === 'audio'" :src="asset.url"></video>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { pinwallUrl } from '../../config'

export default {
  name: 'assets',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['selectedPinwall', 'pinwallAssets', 'user']),
    filteredAssets() {
      const items = this.pinwallAssets
      return items.filter((item, i, arr) => {
        return this.type === '' || this.type === item.type
      })
    }
  },
  data: () => ({
    password: ''
  }),
  methods: {
    ...mapActions(['setPinwall', 'loadPinwallAssets']),
    login() {
      this.selectedPinwall.password = this.password
      this.loadPinwallAssets(this.selectedPinwall)
    },
    back() {
      this.setPinwall(this.selectedPinwall)
    },
    selectAsset(asset) {
      const image = this.pinwallAssets.find((item) => {
        return item.msgId === asset.msgId && item.type === 'image'
      })

      this.$emit('inputAsset', {url: asset.url, poster: image ? image.url : ''})
    },
    openPinwall(item) {
      let url = ''
      if (item.password && item.password !== '') {
        url = `${pinwallUrl}${item.id}?pw=${item.password}`
      } else {
        url = pinwallUrl + item.id
      }

      if (this.user.tenantName !== '' && this.user.tenantName !== 'swisstxt') {
        url = url.replace('http://', `http://${this.user.tenantName}.`)
      }
      window.open(url, '_blank');
    }
  },
  created() {
    this.loadPinwallAssets(this.selectedPinwall)
  }
}
</script>
